const ACTIVE_CLASS = 'is-active';

function initFilterNav() {
	const navs = document.querySelectorAll('.js-filter-nav');

	navs.forEach((nav) => {
		const buttons = nav.querySelectorAll('.js-filter-btn');
		const targetSelector = nav.dataset.filterTarget || '.js-filter-panel';
		const panels = document.querySelectorAll(targetSelector);

		if (!buttons.length || !panels.length) return;

		const filterPanels = (filter) => {
			panels.forEach((panel) => {
				panel.hidden = panel.dataset.category !== filter;
			});
		};

		buttons.forEach((button) => {
			button.addEventListener('click', () => {
				buttons.forEach((target) => {
					target.classList.toggle(ACTIVE_CLASS, target === button);
				});

				filterPanels(button.dataset.filter);
			});
		});

		const activeButton = nav.querySelector(`.js-filter-btn.${ACTIVE_CLASS}`) || buttons[0];
		filterPanels(activeButton.dataset.filter);
	});
}

function initLinkSelect() {
	const groups = document.querySelectorAll('.js-link-select');

	groups.forEach((group) => {
		const buttons = group.querySelectorAll('.js-link-option');
		const targetSelector = group.dataset.linkTarget || '.js-link-target';
		const link = group.parentElement.querySelector(targetSelector);

		if (!buttons.length || !link) return;

		const updateLink = (button) => {
			if (!button.dataset.url) return;

			link.href = button.dataset.url;
		};

		buttons.forEach((button) => {
			button.addEventListener('click', () => {
				buttons.forEach((target) => {
					target.classList.toggle(ACTIVE_CLASS, target === button);
				});

				updateLink(button);
			});
		});

		const activeButton = group.querySelector(`.js-link-option.${ACTIVE_CLASS}`) || buttons[0];
		updateLink(activeButton);
	});
}

export function initNav() {
	initFilterNav();
	initLinkSelect();
}
